// -- External libraries
import { mergeProps } from 'solid-js'

/**
 * Optional `variant` prop values. Omitting `variant` keeps the default button look every existing
 * caller relies on; each value adds a `button-atom-component--<variant>` modifier class.
 */
export const BUTTON_ATOM_VARIANTS = Object.freeze({
    /** Inline text-link look: no chrome, inherits the surrounding type and colour, underlined. */
    LINK: 'link',
})

const KNOWN_VARIANTS = Object.values(BUTTON_ATOM_VARIANTS)

export const useButtonAtomComponentController = (props) => {
    const defaultProps = {}
    const mergedProps = mergeProps(defaultProps, props)

    const variantClass = () => {
        if (mergedProps.variant === undefined) return ''
        if (!KNOWN_VARIANTS.includes(mergedProps.variant)) {
            throw new TypeError(`ButtonAtomComponent: unknown variant "${mergedProps.variant}".`)
        }
        return `button-atom-component--${mergedProps.variant}`
    }

    return {
        mergedProps,
        variantClass,
    }
}
